import MaskedInput from "react-text-mask";

export const TextMaskInput = (props: any) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { InputProps, ...other } = props;
  return <MaskedInput {...other} />;
};
